export default __webpack_public_path__ + "static/media/StepsInactive01.37a05d7f.svg";